import React, { useState, useEffect } from "react";
import { Colors, Web_url, ApiCall } from "../../../common/Const";
import { images } from "../../../common/Images";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import String from "../../../lang/String";
import { useNavigate } from "react-router-dom";
import SkeletonEffect from "./SkeletonEffect";
import { useSelector } from "react-redux";

function Offers(props) {
  const { windowSize, offerData } = props;
  // console.log(windowSize);
  // console.log("best Offers -->", offerData);
    const navigate = useNavigate();
        const user = useSelector((state) => state.auth.user);
        const [cusId, setcusId] = useState(user && user.id > 0 ? user.id : 0);

  const arr = [
    {
      name: "g",
    },
    {
      name: "g",
    },
    {
      name: "g",
    },
    {
      name: "g",
    },
    {
      name: "g",
    },
    {
      name: "g",
    },
    {
      name: "g",
    },
  ];
  const handleClick = (data) => {
    console.log("---->", data);
    navigate("/product-details", { state: { p_detail: data } });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleMostViewedItems = (id) => {
      if (cusId === 0) {
        const guestviewedProducts =
          JSON.parse(sessionStorage.getItem("guestviewedProducts")) || [];

        if (guestviewedProducts.includes(id)) {
          console.log("You have already viewed this product.");
          return;
        }

        //  const viewedParams ={customer_id:cusId,product_id:id};
        const viewedParams = { product_id: id };

        console.log(viewedParams);
        ApiCall("most_viewed", viewedParams)
          .then((data) => {
            console.log(data.message);
            guestviewedProducts.push(id);
            sessionStorage.setItem(
              "guestviewedProducts",
              JSON.stringify(guestviewedProducts)
            );
          })
          .catch((err) => console.log(err));
      } else {
        const viewedProducts =
          JSON.parse(sessionStorage.getItem("viewedProducts")) || [];

        if (viewedProducts.includes(id)) {
          console.log("You have already viewed this product.");
          return;
        }

        //  const viewedParams ={customer_id:cusId,product_id:id};
        const viewedParams = { product_id: id };

        console.log(viewedParams);
        ApiCall("most_viewed", viewedParams)
          .then((data) => {
            console.log(data.message);
            viewedProducts.push(id);
            sessionStorage.setItem(
              "viewedProducts",
              JSON.stringify(viewedProducts)
            );
          })
          .catch((err) => console.log(err));
      }
  };

  return (
    <div className={windowSize > 512 ? "container-fluid px-5 mt-4 mb-0" : "container-fluid mt-4 mb-0"} role="button">
      <p
        className="h3 text-center mt-5 mb-0"
        style={{ color: Colors.Base_color }}
      >
        {String.home_headings.best_offers}
      </p>
      <div className={windowSize > 1440 ? "over-box d-flex flex-row align-items-center justify-content-center container" : "over-box d-flex flex-row align-items-center justify-content-center"}>
        <Swiper
          // slidesPerView={3}
          slidesPerView={
            windowSize != null && windowSize >= 2560
              ? 2
              : windowSize >= 1440
              ? 1.9
              : windowSize >= 1366
              ? 1.8
              : windowSize >= 1280
              ? 1.7
              : windowSize >= 1024
              ? 2
              : windowSize >= 768
              ? 1.6
              : windowSize >= 412
              ? .9
              : windowSize >= 360
              ? .8
              : 1
          }
          spaceBetween={10}
          modules={[Pagination]}
          className="mySwiper"
        >
          {offerData && offerData != null ? (
            <>
              {offerData.map((data) => {
                return (
                  <SwiperSlide>
                    <div
                      className="d-flex flex-row align-items-center offers-box my-5 mx-3"
                      onClick={() =>{handleClick(data);handleMostViewedItems(data.product_id);}}
                    >
                      <div className="p-0">
                        <img
                          src={Web_url.Domain_url + data.product_image[0].url}
                          className="offer-img"
                        />
                      </div>
                      <div
                        className="d-flex flex-column justify-content-center px-4 offer-content"
                        style={{
                          backgroundColor: "#23211D",
                          color: Colors.white_color,
                        }}
                      >
                        <b
                          className="of-b"
                          style={{ color: Colors.white_color }}
                        >
                          Best {data.discount}% offers on
                        </b>
                        {data.product_name.length < 17 ? (
                          <>
                            <strong
                              className="of-strong"
                              style={{ color: Colors.Base_color }}
                            >
                              {data.product_name}
                            </strong>
                          </>
                        ) : (
                          <>
                            <strong
                              className="of-strong"
                              style={{ color: Colors.Base_color }}
                            >
                              {data.product_name.slice(0, 13)}
                            </strong>
                            <strong
                              className="of-strong text-truncate mt-0"
                              style={{ color: Colors.Base_color }}
                            >
                              {data.product_name.slice(12)}
                            </strong>
                          </>
                        )}

                        <b className="of-bb">Collections</b>
                        <button
                          className="btn of-btn"
                          style={{
                            backgroundColor: Colors.Base_color,
                            color: Colors.white_color,
                          }}
                        >
                          Shop Now
                        </button>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </>
          ) : (
            <>
              {arr.map((data) => {
                return (
                  <SwiperSlide>
                    <div className="d-flex flex-row align-items-center offers-box m-5">
                    <SkeletonEffect className={"offers-box"} />
                      {/* <div className="p-0">
                        <img src={images.model1} className="offer-img" />
                      </div>
                      <div
                        className="d-flex flex-column justify-content-center px-4 offer-content"
                        style={{
                          backgroundColor: "#23211D",
                          color: Colors.white_color,
                        }}
                      >
                        <b
                          className="of-b"
                          style={{ color: Colors.white_color }}
                        >
                          Best 30% offers on
                        </b>
                        <strong
                          className="of-strong"
                          style={{ color: Colors.Base_color }}
                        >
                          Platinum & Diamond
                        </strong>
                        <b className="of-bb">Collections</b>
                        <button
                          className="btn of-btn"
                          style={{
                            backgroundColor: Colors.Base_color,
                            color: Colors.white_color,
                          }}
                        >
                          Shop Now
                        </button>
                      </div> */}
                    </div>
                    
                  </SwiperSlide>
                );
              })}
            </>
          )}
        </Swiper>
      </div>
    </div>
  );
}

export default Offers;
